import { render, staticRenderFns } from "./ListarAlunosTurma24.vue?vue&type=template&id=1e1e5cfc&"
import script from "./ListarAlunosTurma24.vue?vue&type=script&lang=js&"
export * from "./ListarAlunosTurma24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports